module.exports = __webpack_public_path__ + "static/media/christopher_portrait.7909157d.png";